module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/magdalena-roman-f800e2b0c6406e4f8ed55080a27ea728.webp";